import React from 'react';
import IdentityEditor from '../components/digital-identity/IdentityEditor';

const DigitalIdentityCreate = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <IdentityEditor />
    </div>
  );
};

export default DigitalIdentityCreate;
